import React from "react";
import { RichTextReference } from "./types";
import Image from "../../components/GatsbyImage";

type Props = {
  reference: RichTextReference;
};

export default function EmbeddedImage({ reference }: Props) {
  const alt = reference.description || "";
  if (reference.gatsbyImageData) {
    return <Image alt={alt} image={reference.gatsbyImageData} />;
  }
  return <img alt={alt} src={reference.localFile?.publicURL || ""} />;
}
